/* Tabs (Dlaczego Łapusie, kenmerken, zekerheden). Het "why"-blok krijgt autoplay met voortgangsbalk,
   parallax en lichtgloed op de kaart, en een intro-animatie. Alles uit bij verminderde beweging. */
(function () {
  if (typeof customElements === 'undefined' || customElements.get('why-lapusie')) return;
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var Tabs = class extends HTMLElement {
    connectedCallback() {
      var tabs = Array.from(this.querySelectorAll('[role=tab]'));
      var panels = Array.from(this.querySelectorAll('[role=tabpanel]'));
      var self = this;
      this.tabs = tabs; this.panels = panels;
      this.show = function (i, focus) {
        tabs.forEach(function (t, n) {
          t.setAttribute('aria-selected', n === i ? 'true' : 'false');
          t.tabIndex = n === i ? 0 : -1;
          panels[n].hidden = n !== i;
        });
        self.current = i;
        if (focus) tabs[i].focus();
        if (self.onShow) self.onShow(i);
      };
      if (!this.closest('lp-perks') && !tabs.some(function (t) { return t.getAttribute('aria-selected') === 'true'; })) this.show(0, false);
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { self.show(i, false); if (self.onManual) self.onManual(); });
        t.addEventListener('keydown', function (e) {
          var n = tabs.length, k = e.key;
          if (k === 'ArrowRight' || k === 'ArrowDown') { e.preventDefault(); self.show((i + 1) % n, true); if (self.onManual) self.onManual(); }
          else if (k === 'ArrowLeft' || k === 'ArrowUp') { e.preventDefault(); self.show((i - 1 + n) % n, true); if (self.onManual) self.onManual(); }
          else if (k === 'Home') { e.preventDefault(); self.show(0, true); if (self.onManual) self.onManual(); }
          else if (k === 'End') { e.preventDefault(); self.show(n - 1, true); if (self.onManual) self.onManual(); }
        });
      });
    }
  };

  customElements.define('lp-perks', class extends Tabs {});

  customElements.define('why-lapusie', class extends Tabs {
    connectedCallback() {
      super.connectedCallback();
      var stage = this.querySelector('.why__stage');
      if (!stage) return; /* kenmerken-tabs op de productpagina: geen extra's */
      var self = this;
      this.stage = stage;
      this.current = this.current || 0;
      this.manual = false;
      var pauseBtn = this.querySelector('[data-why-pause]');
      var auto = this.getAttribute('data-autoplay') === 'true' && !calm;

      this.onShow = function () {
        stage.classList.remove('is-playing');
        void stage.offsetWidth;
        if (auto && !self.manual && self.live) stage.classList.add('is-playing');
      };
      this.onManual = function () {
        self.manual = true;
        stage.classList.remove('is-playing');
        stage.classList.add('is-manual');
        if (pauseBtn) pauseBtn.hidden = true;
      };

      /* intro-animatie en start van de autoplay zodra het blok in beeld komt */
      if ('IntersectionObserver' in window && !calm) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            self.classList.toggle('is-in', e.isIntersecting || self.classList.contains('is-in'));
            self.live = e.isIntersecting;
            if (e.isIntersecting && auto && !self.manual) {
              stage.classList.add('is-playing');
              if (pauseBtn) pauseBtn.hidden = false;
            } else if (!e.isIntersecting) {
              stage.classList.remove('is-playing');
            }
          });
        }, { threshold: 0.35 });
        io.observe(this);
      } else {
        this.classList.add('is-in');
      }

      /* volgende punt zodra de voortgangsbalk vol is */
      stage.addEventListener('animationend', function (e) {
        if (e.animationName !== 'why-bar' || self.manual) return;
        self.show((self.current + 1) % self.tabs.length, false);
      });

      /* pauzeren bij hover, focus en met de knop */
      ['mouseenter', 'focusin'].forEach(function (ev) { stage.addEventListener(ev, function () { stage.classList.add('is-hold'); }); });
      ['mouseleave', 'focusout'].forEach(function (ev) { stage.addEventListener(ev, function () { stage.classList.remove('is-hold'); }); });
      if (pauseBtn) pauseBtn.addEventListener('click', function () {
        var on = pauseBtn.getAttribute('aria-pressed') !== 'true';
        pauseBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
        stage.classList.toggle('is-paused', on);
      });

      /* parallax en lichtgloed op het paneel */
      if (!calm && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        var raf = 0;
        stage.querySelector('.why__panels').addEventListener('pointermove', function (e) {
          if (raf) return;
          var box = e.currentTarget;
          raf = requestAnimationFrame(function () {
            raf = 0;
            var r = box.getBoundingClientRect();
            var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
            box.style.setProperty('--mx', (x * 100) + '%');
            box.style.setProperty('--my', (y * 100) + '%');
            box.style.setProperty('--px', ((x - 0.5) * -24) + 'px');
            box.style.setProperty('--py', ((y - 0.5) * -24) + 'px');
          });
        }, { passive: true });
      }
    }
  });
})();
